module.exports = __webpack_public_path__ + "static/img/info-driver.c0864dd9.svg";